(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["althos-blog-index"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('althos-journal-index'))customElements.define('althos-journal-index',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.topic='all';this.cards=[...this.querySelectorAll('[data-journal-card]')];this.items=[...this.querySelectorAll('[data-journal-item]')];this.search=this.querySelector('[data-journal-search]');this.counter=this.querySelector('[data-journal-count]');this.buttons=[...this.querySelectorAll('[data-topic]')];this.search.addEventListener('input',()=>this.filter());this.buttons.forEach(button=>button.addEventListener('click',()=>{this.topic=button.dataset.topic;this.filter()}));this.querySelector('[data-journal-reset]').addEventListener('click',()=>{this.topic='all';this.search.value='';this.filter();this.search.focus()});this.filter()}normalize(value){return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')}filter(){const query=this.normalize(this.search.value.trim());const visible=new Set;this.cards.forEach(card=>{const matchesTopic=this.topic==='all'||card.dataset.topics.split(' ').includes(this.topic);const matchesSearch=!query||this.normalize(card.dataset.search).includes(query);card.hidden=!(matchesTopic&&matchesSearch);if(!card.hidden)visible.add(card.dataset.key)});this.items.forEach(item=>item.hidden=!visible.has(item.dataset.key));this.counter.textContent=this.counter.dataset.template.replace('__COUNT__',visible.size);this.querySelector('[data-journal-empty]').hidden=visible.size>0;this.buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.topic===this.topic)))}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["althos-catalog"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',event=>{if(!event.target.matches('[data-althos-sort]'))return;const url=new URL(location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete('page');location.assign(url.toString())});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
